/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let sjfBase = window._env_.VUE_APP_SJF_API_HOST
let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST || ''
export const getOrderTable = params => {
  return axios.post(`${base}/order/query`, params)
}

// 待分配列表（order-audit-api）
export const getReviewTaskPendingList = params => {
  return axios.get(`${orderAuditBase}/admin/review-task/pending-list`, { params })
}

// 复核任务列表（主表 audited_order_result，关联一条 audit_task）
export const getQueryReviewTaskList = params => {
  return axios.get(`${orderAuditBase}/admin/audited-order-result/query-review-task-list`, { params })
}

// 待复核任务统计：按 intern_user_id 返回每人待复核工单数（含 name）
export const getPendingReviewTaskStats = params => {
  return axios.get(`${orderAuditBase}/admin/audited-order-result/pending-review-task-stats`, { params })
}

// 复核计划目标配置：按 admin_id、plan_date 查询，无则目标为 0
export const getReviewPlanQuery = params => {
  return axios.get(`${orderAuditBase}/admin/review-plan/query`, { params })
}

// 确认分配：提交来源分配与复核分配配置
export const submitTaskAssignment = data => {
  return axios.post(`${orderAuditBase}/admin/audited-order-result/task-assignment`, data)
}

export const evalReturnOrderApi = params => {
  return axios.post(`${orderAuditBase}/admin/return-order-eval/evaluate/${params.orderid}`, params)
}
export const getReturnOrderEvalResultApi = params => {
  return axios.get(`${orderAuditBase}/admin/return-order-eval/get-result/${params.orderid}`, { params })
}

export const getOrderArchivedTable = params => {
  return axios.post(`${base}/order/query_archived`, params)
}

// 工单申诉管理列表
export const queryOrderAppealTableApi = params => {
  return axios.post(`${base}/order-appeal/query`, params)
}

// 工单申诉-实习生误审统计（按原审核人聚合）
export const queryOrderAppealInternWrongStatApi = params => {
  return axios.post(`${base}/order-appeal/intern_wrong_review_stat`, params)
}

// 工单申诉详情
export const getOrderAppealDetail = ({id}) => {
  return axios.get(`${base}/order-appeal/get_${id}`)
}
export const getOrderAppealByOrderIdApi = ({id}) => {
  return axios.get(`${base}/order-appeal/get_by_order_${id}`)
}
export const orderAppealPassApi = params => {
  return axios.post(`${base}/order-appeal/audit_pass_${params.id}`, params)
}
export const orderAppealRejectApi = params => {
  return axios.post(`${base}/order-appeal/audit_reject_${params.id}`, params)
}

export const orderLocked = params => {
  return axios.post(`${base}/lock_order_${params.orderid}`, params)
}
export const batchSucceed = params => {
  return axios.post(`${base}/order/bulk_complete`, params)
}
export const onBatchSuccceed = params => {
  return axios.post(`${base}/order/batch_complete`, params)
}
export const onBatchWithdraw = params => {
  return axios.post(`${base}/order/batch_withdraw`, params)
}
export const onBatchCheckDetection = params => {
  return axios.post(`${base}/order/batch_audit`, params)
}
export const updateOrderMemo = params => {
  return axios.post(`${base}/order/update_memo`, params)
}
export const exportOrder = params => {
  return axios.post(`${base}/order/export`, params)
}
export const exportOrderArchived = params => {
  return axios.post(`${base}/order/export_archived`, params)
}
export const exportOrderSneakSimilarity = params => {
  return axios.post(`${base}/order/export_sneak_similarity`, params)
}
export const exportOrderLowScoreFaceImgApi = params => {
  return axios.post(`${base}/order/export_low_score_face_img`, params)
}
export const getOrderDetailInfo = ({id}) => {
  return axios.get(`${base}/order/get_${id}`)
}
export const orderWithdraw = params => {
  return axios.post(`${base}/withdraw_order_${params.orderid}`, params)
}
export const orderFinishEnforce = params => {
  return axios.post(`${base}/finish_order_enforce_${params.orderid}`, params)
}
export const orderReset2Finish = params => {
  return axios.post(`${base}/order/reset_to_finish_${params.orderid}`, params)
}
export const orderReset2Process = params => {
  return axios.post(`${base}/order/reset_to_process_${params.orderid}`, params)
}
export const orderVerifyFaceEnforce = ({orderid}) => {
  return axios.post(`${base}/order/pass_verified_face_enforce_${orderid}`)
}
export const getOrderFaceList = ({orderid}) => {
  return axios.get(`${base}/order/get_verified_face_${orderid}`)
}
export const getOrderScoredFaceListApi = (params) => {
  return axios.get(`${base}/order/get_scored_face_${params.orderid}`, {params})
}

export const getMiDanOrderTable = params => {
  return axios.get(`${base}/midan/orderlist/${params.id}`, params)
}
export const allowExchangeOrderApi = params => {
  return axios.post(`${base}/order/allow_exchange`, params)
}
export const exchangeOrderApi = params => {
  return axios.post(`${base}/order/exchange?orderid1=${params.orderid1}&orderid2=${params.orderid2}`, params)
}

export const getOrderLatestCompressDetailApi = (params) => {
  return axios.get(`${base}/order/latest_compress_detail_${params.orderid}`, { params })
}
export const createOrderEvidenceCompressTaskApi = (params) => {
  return axios.get(`${base}/order/compress_evidence_${params.orderid}`, { params })
}

// SJF 二维码识别
export const getRecognizeQrcodeData = params => {
  return axios.post(`${sjfBase}/admin/admin2/recognize_qrcode`, params)
}

export const getQrcodeContentData = params => {
  return axios.post(`${sjfBase}/admin/admin2/cli_read_qrcode`, params)
}




// WEBPACK FOOTER //
// ./src/views/order/order.api.js